<template>
  <!-- <AddForm :is-add="true" :set-flag="setFlag" parent-name="BusinessGoodsSkuOrdinary" /> -->
  <ViewForm :is-view="true" :set-flag="setFlag" parent-name="BusinessGoodsSkuOrdinary" />
</template>
<script>
// import AddForm from '../components/addForm.vue';
import ViewForm from '../components/ViewForm.vue';
import { GOODS_COMBO_TYPES } from '@/utils/constants';
export default {
  name: 'BusinessGoodsSkuOrdinaryAdd',
  components: {
    // AddForm,
    ViewForm
  },
  data() {
    return {};
  },
  computed: {
    setFlag() {
      return GOODS_COMBO_TYPES.ORDINARY;
    },
  },
  watch: {},

  mounted() {},
  methods: {},
};
</script>
